export const constRoute = {
  draftProject: "/project/draft",
  gradeProject: "/project/evaluate",
  advisorProject: "/project/advisor",
  cnConverterProject: "/project/converter",
  theoryOfChangeProject: "/project/theory-of-change",
  noObjectionProcedureProject: "/project/no-objection-procedure",
  rationalAdvisorProject: "/project/rational-advisor",
  root: "/",
  home: "/home",
  login: "/login",
  faqs: "/faqs",
  playground: "/playground",
  TermOfUse: "/term-of-use",
  DataSecurityAssurance: "/data-security-assurance",
  projectResult: "/project-result",
  softwareAttribution: "software-attribution",
  admin: "/admin",
  adminDashboard: "/admin/dashboard",
  adminUsers: "/admin/users",
  adminBilling: "/admin/billing",
  masterAdminRoot: "/masteradmin",
  masteradminDashboard: "/masteradmin/dashboard",
  masteradminUsers: "/masteradmin/users",
  masteradminPromptPanel: "/masteradmin/prompt-panel",
  masteradminResource: "/masteradmin/resource-center",
  masteradminBilling: "/masteradmin/billing",
  masteradminLogin: "/masteradmin/login",
  gradeSelectMode: "/evaluate-mode-selection",
  gradeWelcome: "/grade-welcome",
  theoryOfChangeWelcome: "/theory-of-change-welcome",
  rationalAdvisorWelcome: "/rational-advisor-welcome",
  projectStructureWelcome: "/project-structure-welcome",
  cnConverterWelcome: "/converter-welcome",
  gcfCongratulation: "/gcf-congratulation",
  signup: "/signup",
  forgetPassword: "/forget-password",
  checkEmail: "/check-email",
  setNewPassword: "/set-new-password",
  resetPasswordSuccessfully: "/reset-password-successfully",
  verifyEmail: "/verify-email",
  selectFunder: "/select-funder",
  selectFunction: "/select-function",
  selectDonor: "/select-donor",
  selectOne: "/select-one",
  whichToDo: "/which-to-do",
  projectName: "/project-name",
  finalSheet: "/final-sheet",
  profile: "/profile",
  privacyPolicy: "/privacy-policy",
  existingProject: "/myProjects",
  pricing: "/pricing",
};
